import React from 'react';
import {
    css,
    Grid,
} from "@bdfx/fukit"
import tym from '../../resources/tym.jpg';
import trans from "../trans"

export const Footer = () => <Style className="section audit-footer">
    <Grid cols="200px 1fr" gap="50px" valign="center">
            <div id="audit-end">
                <img width="200" height="200" src={tym} alt="Tým Bidding Fox" title="Tým Bidding Fox" />
            </div>
            <p>
                {trans("audit_result_footer")}
            </p>
    </Grid>
</Style>


export const Style = css("div")({
    fontSize: "1.4em",
    paddingBottom: "200px",
    background: "#ffeced",
    "> div": {
        maxWidth: "1100px",
        margin: "auto",
        textAlign: "left",
    },
    "img": {
        clipPath: "circle(99px at center)",
    },

    "@media only screen and (max-width: 1000px)": {
        ".fuk-grid": {
            display: "block",
            textAlign: "center",
        },
    },
})

export default Footer;
